/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from 'react';
import { Form, Formik, Field } from 'formik';
import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import FileModal from 'components/FileModal';
import * as yup from 'yup';
import { FitinsurAPI, MessageCenter } from 'utils';
import TextField from 'components/Form/TextField';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Scrollbox, ButtonContent } from './styles';
import { LostCancelButton, TextEditorBox } from 'components/index';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import HasPermission from 'components/HasPermission/index';
import { useOperationInfo } from 'services/OperationService';
import { useHeaderNbi, useDocument, useSendApprove } from 'services/QuoteService';

export default function NbiRequestCv(props) {
  const [summary, setSummary] = useState({});
  const [file, setFile] = useState();
  const [historymsg, setHistorymsg] = useState([]);
  const [isBound, setIsBound] = useState(false);
  const [initialNbiMessage, setInitialNbiMessage] = useState("");
  
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const formik = useRef(null);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useDocumentData,
    loading: useDocumentLoading,
    error: useDocumentError,
    status: useDocumentStatus,
    request: useDocumentRequest,
  } = useDocument();

  const {
    data: useSendApproveData,
    loading: useSendApproveLoading,
    error: useSendApproveError,
    status: useSendApproveStatus,
    request: useSendApproveRequest,
  } = useSendApprove();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  useEffect(() => {
    if (useHeaderNbiLoading || useOperationInfoLoading || useDocumentLoading || useSendApproveLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useOperationInfoLoading, useDocumentLoading, useSendApproveLoading]);

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleFile() {
    useDocumentRequest({idOperation: props.match.params.idOperation, idTemplate: 3}, null).then((a) => {
        if (a.status !== 200) {
            mc.error(`There was an error while fetching your data: ${handleFile.name}\n`);
            history.goBack();
            return;
        } else {
            setFile(a.data);
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
        console.error('fitPostDocument - Error:', error);
      });
  };

  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate}
            ${message.approvalComments}
      
              `;
          tempmessage = (tempmessage + tempMsg);
        }
      )
      return tempmessage;
    }
  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        setHistorymsg(data.ret_value.historical);
        setInitialNbiMessage(data.ret_value.nbiClientSubjectMessage)

        if (
          data.ret_value.nbiAdditionalsSubjectivityInsurers && 
          data.ret_value.nbiAdditionalsSubjectivityInsurers.length
        ) {
          let subjectivityInsurers = '';
          for(const sub of data.ret_value.nbiAdditionalsSubjectivityInsurers){
            subjectivityInsurers = subjectivityInsurers + sub.subjectivityFormatted + '\n';
          }

          formik.current?.setFieldValue('additionalNbiClientSubjectivity', subjectivityInsurers)
        }
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleBack() {
    history.goBack();
  }

  async function handleSendApproval(values) {
    values.idOperation = props.match.params.idOperation;

    useSendApproveRequest({idOperation: values.idOperation, nbiClientSubjectMessage: values.nbiClientSubjectMessage, 
      additionalNbiClientSubjectivity: values.additionalNbiClientSubjectivity
    }, null).then(({data: resp}) => {
      if (resp.ret_code != 200) {
        mc.error(resp.ret_msg_details);
        return;
      }
      history.push(`/broking/approval-nbi-cv/${props.match.params.idOperation}`, { idProduct: props.location.state.idProduct });
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleSendApproval.name}\n` + error);
      console.error('fitPostAproveNBI - Error:', error);
    });


  };

  useEffect(() => {
    let v = handleHistoryMessage()
    if (formik.current) {
      formik.current?.setFieldValue('dealAnalisysInformation', v)
    }
  }, [historymsg])

  const handleOperationInfo = () => {
    useOperationInfoRequest().then(({data}) => {
      setIsBound(data.isBound || false)
      })
  }

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    handleOperationInfo();
    handleFile();
    handleSummary();
  }, [])

  const validation = yup.object().shape({
    nbiClientSubjectMessage: yup.string().required("* Required field"),
    additionalNbiClientSubjectivity: yup.string().required("* Required field"),
  });

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"}>
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <Scrollbox>
        <BrokingSummary data={summary ? summary : ''} />
        <ContentCard title="GENERATE NBI" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
          <Formik
            innerRef={formik}
            initialValues={{
              nbiClientSubjectMessage: '',
              additionalNbiClientSubjectivity: '',
              dealAnalisysInformation: ''
            }}
            validationSchema={validation}
            onSubmit={handleSendApproval}
          >
            {formikProps => {
              return (
                <Form>
                  <TextEditorBox
                    label="NBI Message - (External)"
                    name="nbiClientSubjectMessage"
                    onChange={(e) => formikProps?.setFieldValue('nbiClientSubjectMessage', e)}
                    error={formikProps.touched.nbiClientSubjectMessage && formikProps.errors.nbiClientSubjectMessage ? formikProps.errors.nbiClientSubjectMessage : null}
                    initialValue={initialNbiMessage}
                    disabled={isBound}
                  />

                  <Field
                    label={'Additional subjectivities or questions'}
                    name={'additionalNbiClientSubjectivity'}
                    value={formikProps.values.additionalNbiClientSubjectivity}
                    onChange={(e) => formikProps?.setFieldValue('additionalNbiClientSubjectivity', e)}
                    component={TextField}
                    readOnly={isBound}
                  />

                  <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
                  <Field
                    readOnly
                    label={'Deal Analysis Information'}
                    name={'dealAnalisysInformation'}
                    value={formikProps.values.dealAnalisysInformation}
                    onChange={(e) => formikProps?.setFieldValue('dealAnalisysInformation', e)}
                    component={TextField}
                  />
                  <ButtonContainer>
                    <Button forth onClick={() => handleBack()}>&lt; Back</Button>
                    <HasPermission permission={!isBound}>
                      <RenderButtons idOperation={props.match?.params?.idOperation}>
                        <ButtonContent>
                          <div style={{ marginTop: "5px" }} >
                            <LostCancelButton idOperation={props.match?.params?.idOperation} />
                          </div>
                          <HasPermission permission={props.permissions.NBI_SEND_APPROVAL}>
                            <Button primary type="submit" style={{ marginLeft: "10px", marginTop: "5px" }} >
                              SEND APPROVAL
                            </Button>
                          </HasPermission>
                        </ButtonContent>
                      </RenderButtons>
                    </HasPermission>
                  </ButtonContainer>
                </Form>
              )
            }}
          </Formik>
        </ContentCard>
      </Scrollbox>
    </Layout >
  )
}
